<template>
    <div class="fill-height">
        <MapBasic :key="$route.name" :beforeLeave="beforeLeave"
                  :loading-data="loadingData"
                  :zone="zone" :zone-name="zoneName" class="map-container" edit-points
                  @hasChanges="hasChangesStatus" @saveZone="saveZone"/>
        <ZoneNameDialog :open="openNameDialog" :zone-name="zoneName" @close="close" @save="saveZoneName"/>
        <LeaveConfirmDialog ref="leaveConfirmDialog"/>
    </div>
</template>

<script>
import MapBasic from "@/components/MapBasic/MapBasic";
import ZoneNameDialog from "@/components/Zones/ZoneNameDialog";

export default {
  name: "AddEditZone",
  components: {ZoneNameDialog, MapBasic},
  provide() {
    const zoneInjection = {};
    Object.defineProperty(zoneInjection, 'zone', {
      enumerable: true,
      get: () => this.zone,
    });
    return {zoneInjection, refreshZone: this.initZone};
  },
  mounted() {
    if (this.isEdit) {
      this.initZone();
    }
  },
  data() {
    return {
      openNameDialog: false,
      zoneName: '',
      zone: {},
      loading: false,
      loadingData: false,
      refreshCounter: 0,
      hasChanges: false,
      beforeLeave: false,
    };
  },
  watch: {
    isEdit(val) {
      if (val) {
        this.initZone();
      }
    }
  },
  computed: {
    isEdit() {
      return ['editZone', 'zoneManagement', 'geofenceHistory'].includes(this.$route.name);
    },
    items() {
      if (!this.isEdit) {
        return [];
      }
      return [
        {
          title: this.$t('zone'),
          to: {
            name: 'editZone',
            params: {
              id: this.$route.params.id
            }
          }
        },
        {
          title: this.$t('zones.zoneManagement'),
          to: {
            name: 'zoneManagement',
            params: {
              id: this.$route.params.id
            }
          }
        },
        {
          title: this.$t('zones.geofenceHistory'),
          to: {
            name: 'geofenceHistory',
            params: {
              id: this.$route.params.id
            }
          }
        }
      ];
    }
  },
  methods: {
    saveZoneName(name) {
      this.zoneName = name;
      this.openNameDialog = false;
    },
    editText() {
      this.openNameDialog = true;
      alert('asd');
    },
    close() {
      if (this.zoneName) {
        this.openNameDialog = false;
      } else {
        this.$router.back();
      }
    },
    hasChangesStatus(status) {
      this.hasChanges = status;
    },
    saveZone(data) {
      let url = this.$store.getters.zones;
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$store.dispatch('setLoader', true);
      if (this.isEdit) {
        url = this.$store.getters.zone(this.$route.params.id);
        this.axios.patch(url, data).then(() => {
          this.$store.dispatch('addNotification', {
            type: 'success',
            message: this.$t('success.zoneWasUpdated'),
          });
          this.initZone();
        }).finally(() => {
          this.loading = false;
          this.$store.dispatch('setLoader', false);
        });
      } else {
        this.axios.post(url, data).then(({data}) => {
          this.hasChanges = false;
          this.$router.replace({name: 'editZone', params: {id: data.Result}});
          this.$store.dispatch('addNotification', {
            type: 'success',
            message: this.$t('success.zoneWasCreated'),
          });
        }).finally(() => {
          this.loading = false;
          this.$store.dispatch('setLoader', false);
        });
      }
    },
    initZone() {
      const url = this.$store.getters.zones + this.$route.params.id;
      this.loadingData = true;
      this.axios.get(url).then(({data}) => {
        this.zone = data.Result;
        this.zoneName = data.Result.Name;
      }).finally(() => {
        this.loadingData = false;
      });
    },
    navigateBack() {
      this.$router.back();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges || (!this.isEdit && this.zoneName)) {
      this.beforeLeave = true;
      this.$refs.leaveConfirmDialog.openDialog().then((res) => {
        if (res) {
          next();
        }
        this.next = next;
        next(false);
      }).finally(() => {
        setTimeout(() => {
          this.beforeLeave = false;
        }, 300);
      });
    } else {
      return next();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "add-edit-zone";
</style>